import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

export default function Services({ language = "en", darkMode = false }) {
  const [isDark, setIsDark] = useState(darkMode);

  const location = useLocation();

  useEffect(() => {
    const scrollToService = () => {
      const targetId = location.state?.scrollTo;
      if (targetId) {
        const element = document.getElementById(targetId);
        if (element) {
          element.scrollIntoView({ behavior: "smooth", block: "center" });
        } else {
          // Retry after a short delay if element isn't found (for animations/loading)
          setTimeout(scrollToService, 500);
        }
      }
    };

    scrollToService();
  }, [location.state?.scrollTo]);
  useEffect(() => {
    const checkDarkMode = () => {
      setIsDark(document.body.classList.contains("dark-mode"));
    };

    checkDarkMode();
     // Scroll to service if hash exists (#service-x)
    

    const observer = new MutationObserver(checkDarkMode);
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ["class"],
    });

    return () => observer.disconnect();
  }, []);

  // translations
  const translations = {
    en: {
      title: "OUR SERVICES",
      services: [
        {
          id: "service-1",
          title: "VPS Server & Cloud Services",
          image: "/images/home/VPS.jpg",
          description:
            "Our VPS and cloud hosting services provide scalable, secure, and high-performance solutions tailored to meet the demands of modern businesses. With 24/7 uptime monitoring, automated backups, and integration with leading cloud platforms, you can ensure smooth operations and reliability without infrastructure headaches.",
        },
        {
          id: "service-2",
          title: "WhatsApp Chatbot & Communication",
          image: "/images/services/WhatsApp.png",
          description:
            "Enhance customer engagement with our WhatsApp chatbot solutions. From automating FAQs to providing real-time support and broadcasting updates, our chatbot empowers businesses to build stronger relationships while reducing manual workload. Designed for scalability and seamless integration with your existing systems.",
        },
        {
          id: "service-3",
          title: "ERP Implementation & Consulting",
          image: "/images/services/ERPConsulting.png",
          description:
            "We offer complete ERP consulting and implementation services to streamline operations, improve efficiency, and centralize data management. Our team ensures proper requirement analysis, custom module development, and staff training so your business gets maximum ROI and long-term sustainability.",
        },
        {
          id: "service-4",
          title: "AI Automation",
          image: "/images/services/AIAutomation.jpg",
          description:
            "Our AI-driven automation services help businesses save time, reduce costs, and eliminate repetitive tasks. From intelligent workflows and predictive analytics to process optimization, we deliver solutions that unlock productivity, accuracy, and innovation for your organization’s future growth.",
        },
        {
          id: "service-5",
          title: "Website Development",
          image: "/images/services/Mobile.png",
          description:
            "We design and develop websites with modern UI/UX, SEO optimization, and responsive layouts. Our websites are tailored to your brand identity, ensuring fast load speeds, secure code, and scalability. Perfect for businesses seeking online credibility and growth.",
        },
        {
          id: "service-6",
          title: "Mobile App Development & Customization",
          image: "/images/services/MobileApp3.png",
          description:
            "Build mobile apps that engage users and grow your business. We create cross-platform and native apps with custom features, user-friendly design, and smooth performance. From startups to enterprises, our apps adapt to your needs and scale effortlessly.",
        },
        {
          id: "service-7",
          title: "Hardware Services",
          image: "/images/home/Hardware.jpg",
          description:
            "We provide complete hardware solutions including installation, maintenance, and IT infrastructure support. Our experts ensure smooth operations with timely troubleshooting, reliable setups, and performance monitoring to keep your business running without disruptions.",
        },
        {
          id: "service-8",
          title: "Custom ERP Solutions",
          image: "/images/services/ERPSolution.png",
          description:
            "Our custom ERP solutions are designed to fit your business workflows perfectly. With tailored modules, real-time analytics, and scalable architecture, we help you manage operations seamlessly while reducing inefficiencies and boosting overall productivity.",
        },
      ],
    },
    ar: {
      title: "خدماتنا",
      services: [
        {
          id: "service-1",
          title: "خادم VPS والخدمات السحابية",
          image: "/images/home/VPS.jpg",
          description:
            "نقدم استضافة VPS وخدمات سحابية موثوقة وقابلة للتوسع مع ميزات متقدمة لضمان الأداء العالي والأمان. يتم توفير نسخ احتياطية تلقائية ومراقبة مستمرة على مدار الساعة لتقليل الأعطال وضمان استمرارية الأعمال بسهولة.",
        },
        {
          id: "service-2",
          title: "روبوت دردشة واتساب والتواصل",
          image: "/images/services/WhatsApp.png",
          description:
            "حلول روبوتات واتساب الذكية تعزز تواصلك مع العملاء من خلال الردود التلقائية والدعم الفوري. يمكن استخدامها للإجابة على الأسئلة الشائعة، إرسال التحديثات، وتحسين تفاعل العملاء بشكل فعال مع عملك.",
        },
        {
          id: "service-3",
          title: "تنفيذ واستشارات ERP",
          image: "/images/services/ERPConsulting.png",
          description:
            "نساعد الشركات على تنفيذ أنظمة ERP بشكل كامل من خلال الاستشارات المتخصصة، تطوير الوحدات المخصصة، والتدريب لضمان تحسين العمليات الإدارية وزيادة الكفاءة وتقليل الأخطاء.",
        },
        {
          id: "service-4",
          title: "الأتمتة بالذكاء الاصطناعي",
          image: "/images/services/AIAutomation.jpg",
          description:
            "نقدم حلول أتمتة تعتمد على الذكاء الاصطناعي لتقليل الوقت المستهلك في المهام المتكررة. تساعد هذه الحلول في تحسين الكفاءة، تقديم تحليلات تنبؤية، وتقليل التكاليف التشغيلية.",
        },
        {
          id: "service-5",
          title: "تطوير المواقع الإلكترونية",
          image: "/images/services/Mobile.png",
          description:
            "نطور مواقع إلكترونية حديثة تتميز بتصميمات جذابة وتجربة مستخدم متطورة. يتم تحسين المواقع لمحركات البحث وتكون متجاوبة مع جميع الأجهزة لضمان أداء وسرعة مثاليين.",
        },
        {
          id: "service-6",
          title: "تطوير وتخصيص تطبيقات الهاتف",
          image: "/images/services/MobileApp3.png",
          description:
            "نصمم تطبيقات محمولة أصلية وعبر الأنظمة بمزايا مخصصة لتلبية احتياجاتك. يتميز عملنا بسهولة الاستخدام، التصميم العصري، والتوسع المستقبلي بما يتناسب مع نمو عملك.",
        },
        {
          id: "service-7",
          title: "خدمات الأجهزة",
          image: "/images/home/Hardware.jpg",
          description:
            "نقدم خدمات شاملة في إعداد الأجهزة وصيانتها ودعم البنية التحتية لتقنية المعلومات. يضمن فريقنا المحترف استقرار النظام وحل المشكلات بسرعة لضمان استمرارية أعمالك.",
        },
        {
          id: "service-8",
          title: "حلول ERP مخصصة",
          image: "/images/services/ERPSolution.png",
          description:
            "نطور حلول ERP مخصصة تتناسب مع احتياجات صناعتك. تتيح هذه الحلول إدارة العمليات بكفاءة أعلى، تقليل الهدر، وتحقيق نمو متسارع في عملك.",
        },
      ],
    }
  };

  const currentLang = translations[language] || translations.en;

  return (
    <section
      style={{
        width: "100%",
        padding: "30px 0px",
        textAlign: "center",
        background: isDark ? "#121212" : "#f9f9f9",
      }}
    >
      {/* Heading (keep default font in English, Amiri in Arabic) */}
      <h2
        style={{
          fontSize: 36,
          fontWeight: language === "ar" ? 400 : 800,
          marginBottom: 20,
          textTransform: "uppercase",
          color: isDark ? "#fff" : "#126",
          fontFamily: language === "ar" ? "'Amiri', serif" : "inherit",
        }}
      >
        {currentLang.title}
      </h2>

      <div
        style={{
          width: "120px",
          height: "5px",
          margin: "0 auto 50px",
          borderRadius: "20px",
          background: "linear-gradient(to right, #00BFFF, #1E90FF)",
        }}
      />

      <div className="cards-container">
        {currentLang.services.map((service, i) => (
          <div
            key={i}
            id={service.id}
            className={`card ${i % 2 === 0 ? "from-left" : "from-right"}`}
          >
            <div className="image-wrapper">
              <img src={service.image} alt={service.title} />
            </div>
            <h3
              style={{
                fontFamily:
                  language === "ar" ? "'Amiri', serif" : "'Exo 2', sans-serif",
                fontWeight: "bold",
              }}
            >
              {service.title}
            </h3>
            <p
              style={{
                fontFamily:
                  language === "ar" ? "'Amiri', serif" : "'Exo 2', sans-serif",
                fontWeight: 400,
              }}
            >
              {service.description}
            </p>
          </div>
        ))}
      </div>

      <style>{`
        .cards-container {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 30px;
          max-width: 1100px;
          margin: 0 auto;
        }

        .card {
            opacity: 0;
            transform: translateY(50px);
            border-radius: 20px;
            padding: 20px;
            background: ${isDark ? "#1f2937" : "#fff"};
            border: 1.5px solid dodgerblue;
            box-shadow: ${isDark 
              ? "0 2px 8px rgba(30, 144, 255, 0.4)"   /* faint DodgerBlue glow */
              : "0 2px 8px rgba(204, 204, 204, 0.6)"}; /* faint soft gray */
            text-align: center;
            transition: transform 0.4s ease, box-shadow 0.4s ease;
            animation: fadeUp 1s ease forwards;
        }

        .card:hover {
            transform: translateY(-10px) scale(1.05);
            box-shadow: ${isDark 
              ? "0 12px 35px rgba(30, 144, 255, 1)"   /* big DodgerBlue glow */
              : "0 12px 35px rgba(170, 170, 170, 1)"}; /* stronger gray glow */
        }

        @media (min-width: 769px) {
          .card.from-left { animation: slideInLeft 1s ease forwards; }
          .card.from-right { animation: slideInRight 1s ease forwards; }
        }

        .card:nth-child(1) { animation-delay: 0.1s; }
        .card:nth-child(2) { animation-delay: 0.2s; }
        .card:nth-child(3) { animation-delay: 0.3s; }
        .card:nth-child(4) { animation-delay: 0.4s; }
        .card:nth-child(5) { animation-delay: 0.5s; }
        .card:nth-child(6) { animation-delay: 0.6s; }
        .card:nth-child(7) { animation-delay: 0.7s; }
        .card:nth-child(8) { animation-delay: 0.8s; }

        @keyframes slideInLeft {
          0% { opacity: 0; transform: translateX(-100px); }
          100% { opacity: 1; transform: translateX(0); }
        }
        @keyframes slideInRight {
          0% { opacity: 0; transform: translateX(100px); }
          100% { opacity: 1; transform: translateX(0); }
        }
        @keyframes fadeUp {
          0% { opacity: 0; transform: translateY(50px); }
          100% { opacity: 1; transform: translateY(0); }
        }

        .image-wrapper {
          width: 100%;
          height: 300px;
          overflow: hidden;
          border-radius: 10px;
          border:1px solid royalblue;
          margin: 0;
        }
        .image-wrapper img {
          width: 100%;
          height: auto;
          object-fit: cover;
          transition: transform 0.4s ease;
        }
        .image-wrapper:hover img {
          transform: scale(1.1);
        }

        @media (max-width: 768px) {
          .cards-container {
            grid-template-columns: 1fr;
            padding: 0 15px;
          }
          .image-wrapper {
            width: 100%;
            height: auto;
            overflow: hidden;
            border-radius: 10px;
            margin: 0;
          }
          .image-wrapper img {
            width: 100%;
            height: auto;
            object-fit: contain;
            transition: transform 0.4s ease;
          }
        }
      `}</style>
    </section>
  );
}